import React from 'react';
import ConsumptionBreakdown from './ConsumptionBreakdown';
import { connect } from 'react-redux';
import { fetchItemizationWidgetData } from '../../../../dataFetchers/itemizationDataFetcher';
import { Paper } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { DASHBOARD_SURVEY_PATH } from '../../../../constants/paths';
import { resetMonthlySummaryData } from '../../../../actions/monthlySummaryActions';
import { trackEvent } from '../../../../helpers/analyticsHelper';
import { PAGE_EVENT_NAMES , DASHBOARD , FUEL_TYPE, HOME_PAGE_WIDGETS }  from '../../../../constants/common';

class ConsumptionBreakDownContainer extends React.Component{
    componentDidMount(){
        if(!this.props.itemizationData){
            this.props.fetchItemizationWidgetData(this.props.userId, {
                disclaimer: this.props.translations.data["HOME.CONSUMPTION_BREAKDOWN.DUMMY_DATA.DISCLAIMER"]
            }, this.props.configs.data["date_format"],this.props.configs.data['fuelType'].toUpperCase());
        }
    }
    goToSurvey() {
        trackEvent(this.props.userId, PAGE_EVENT_NAMES.DASHBOARD , {
            clicked: DASHBOARD.HOME_ASSESSMENT_SURVEY,
            dashboardView: FUEL_TYPE.ELECTRIC,
            widget: HOME_PAGE_WIDGETS.CONSUMPTION_BREAKDOWN
        })
        this.props.history.push(DASHBOARD_SURVEY_PATH);
      }

    render(){
        return(
            <Paper className="app-breakdown-container">
                {this.props.itemizationData && <ConsumptionBreakdown itemizationData={this.props.itemizationData.data} translations={this.props.translations} applianceList={this.props.applianceList}
                    goToSurvey={() => this.goToSurvey()} resetMonthlySummaryData={() => this.props.resetMonthlySummaryData()} itemizationDataFailed={this.props.itemizationData.failed} 
                    displayValue={this.props.configs.data['itemizationWidget.displayValue']} fuelType={this.props.configs.data.fuelType} userId={this.props.userId}/>
                }
            </Paper>
        )
    }
}

const mapStateToProps = state => {
    return {
        userId: state.userIdentityDetails.userId,
        itemizationData : state.itemizationWidgetData,
        translations: state.translationsData,
        applianceList: state.appliances.appliancesList,
        configs: state.configs
    }
}

const mapDispatchToProps = dispatch => {
    return{
        fetchItemizationWidgetData : (uuid, translations, dateFormat,measurementType) => dispatch(fetchItemizationWidgetData(uuid, translations, dateFormat, measurementType)),
        resetMonthlySummaryData : () => dispatch(resetMonthlySummaryData())
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConsumptionBreakDownContainer));